import { render, staticRenderFns } from "./googleAdsPopup.vue?vue&type=template&id=229fa0e2&scoped=true&"
import script from "./googleAdsPopup.vue?vue&type=script&lang=js&"
export * from "./googleAdsPopup.vue?vue&type=script&lang=js&"
import style0 from "./googleAdsPopup.vue?vue&type=style&index=0&id=229fa0e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229fa0e2",
  null
  
)

export default component.exports